/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as SpotlightWithLabel } from './spotlight-with-label.story';
export { default as SpotlightWithIcon } from './spotlight-with-icon.story';
export { default as SpotlightWithImage } from './spotlight-with-image.story';
export { default as SpotlightWithPointer } from './spotlight-with-pointer.story';
export { default as SpotlightTour } from './spotlight-tour.story';
export { default as SpotlightInSideNav } from './spotlight-in-side-nav.story';
export { default as SpotlightInDialog } from './spotlight-in-dialog.story';
export { default as SpotlightFixedPositioning } from './spotlight-fixed-positioning.story';
export { default as SpotlightOnTabs } from './spotlight-on-tabs.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import SpotlightFixedPositioningSrcRaw from './spotlight-fixed-positioning.story?raw';
import SpotlightInDialogSrcRaw from './spotlight-in-dialog.story?raw';
import SpotlightInSideNavSrcRaw from './spotlight-in-side-nav.story?raw';
import SpotlightOnTabsSrcRaw from './spotlight-on-tabs.story?raw';
import SpotlightTourSrcRaw from './spotlight-tour.story?raw';
import SpotlightWithIconSrcRaw from './spotlight-with-icon.story?raw';
import SpotlightWithImageSrcRaw from './spotlight-with-image.story?raw';
import SpotlightWithLabelSrcRaw from './spotlight-with-label.story?raw';
import SpotlightWithPointerSrcRaw from './spotlight-with-pointer.story?raw';

export const SpotlightWithLabelSrc = removeLicenseHeader(
  SpotlightWithLabelSrcRaw,
);
export const SpotlightWithIconSrc = removeLicenseHeader(
  SpotlightWithIconSrcRaw,
);
export const SpotlightWithImageSrc = removeLicenseHeader(
  SpotlightWithImageSrcRaw,
);
export const SpotlightWithPointerSrc = removeLicenseHeader(
  SpotlightWithPointerSrcRaw,
);
export const SpotlightTourSrc = removeLicenseHeader(SpotlightTourSrcRaw);
export const SpotlightInSideNavSrc = removeLicenseHeader(
  SpotlightInSideNavSrcRaw,
);
export const SpotlightInDialogSrc = removeLicenseHeader(
  SpotlightInDialogSrcRaw,
);
export const SpotlightFixedPositioningSrc = removeLicenseHeader(
  SpotlightFixedPositioningSrcRaw,
);
export const SpotlightOnTabsSrc = removeLicenseHeader(SpotlightOnTabsSrcRaw);
